import { useQuery } from '@apollo/client';

import { CompanyInvitationsQuery, CompanyInvitationsQueryVariables } from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CompanyInvitations, InvitationsViewProps } from '../components/company_invitations';
import { companyInvitationsQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyInvitationsQuery,
  InvitationsViewProps,
  CompanyInvitationsQueryVariables
> {}

export const CompanyInvitationsContainer = (props: { companyId: string }) => {
  const result = useQuery<CompanyInvitationsQuery, CompanyInvitationsQueryVariables>(companyInvitationsQuery, {
    variables: {
      company_id: props.companyId,
    },
  });

  return (
    <LoadingContainer result={result} mapData={({ data }) => ({ companyInvitations: data.companyInvitations ?? [] })}>
      {(props) => <CompanyInvitations {...props} />}
    </LoadingContainer>
  );
};
